import {
  Children,
  cloneElement,
  FC,
  isValidElement,
  ReactElement,
  useState,
} from "react";

import { useTestReport } from "@repo/edtech-api";
import { Loader, Modal } from "@repo/edtech-ui-kit";

import st from "./ShowResultsModal.module.scss";

const ShowResultsContent = ({
  lessonUid,
}: {
  lessonUid: string,
}) => {
  const {
    data: questions,
    isLoading,
    error,
  } = useTestReport({
    testId: lessonUid,
    enabled: true,
  });

  return (
    <div className={st.wrap}>
      {
        isLoading && (
          <div className={st.loader_wrap}>
            <Loader />
          </div>
        )
      }
      {
        !isLoading && error && (
          <div className={st.loader_wrap}>
            Ошибка получения результата
          </div>
        )
      }
      {
        questions && (
          <div className={st.content}>
            <h3 className={st.title}>Отчет прохождения теста</h3>
            <table>
              <thead>
                <tr>
                  <th>№</th>
                  <th>Вопрос / Ответ</th>
                  <th className={st.user_answer}>Ваш ответ</th>
                  <th>
                    <span className={st.title_desktop}>Оценка</span>
                    <span className={st.title_mobile}>Оц.</span>
                  </th>
                </tr>
              </thead>
              <tbody>
                {
                  questions?.map(({
                    uid,
                    question,
                    userAnswer,
                    correctAnswer,
                    ball,
                  }, index) => (
                    <tr key={uid}>
                      <td>{index+1}</td>
                      <td className={st.question}>
                        <div>
                          <span className={st.text_gr}>Вопрос: </span>
                          <span className={st.text}>{question}</span>
                        </div>
                        <div>
                          <span className={st.text_gr}>Правильный ответ: </span>
                          <span className={st.text}>{correctAnswer?.replace(/\|/g, ", ")}</span>
                        </div>
                        <div className={st.user_answer_mobile}>
                          <span className={st.text_gr}>Ваш ответ: </span>
                          <span className={st.text}>{userAnswer?.replace(/\|/g, ", ")}</span>
                        </div>
                      </td>
                      <td className={st.user_answer}>{userAnswer?.replace(/\|/g, ", ")}</td>
                      <td>{ball}</td>
                    </tr>
                  ))
                }
              </tbody>
            </table>
          </div>
        )
      }
    </div>
  );
};

type Props = {
  Trigger: ReactElement,
  lessonUid: string,
};

export const ShowResultsModal: FC<Props> = ({
  Trigger,
  lessonUid,
}) => {
  const [ isOpenModal, setIsOpenModal ] = useState(false);

  const onClickShowResult = () => {
    setIsOpenModal(true);
  };

  const TriggerWithProps = Trigger ? (
    Children.map(Trigger, (child: ReactElement) => {
      if (isValidElement(child)) {
        return cloneElement(child as ReactElement<any>, {
          onClick: onClickShowResult,
        });
      }
      return child;
    })
  ) : (
    <></>
  );

  return (
    <>
      <Modal
        insideWrapClassName={st.inside_wrap}
        isInsideCloseBtn={false}
        isOpen={isOpenModal}
        Trigger={TriggerWithProps as ReactElement}
        onClose={() => setIsOpenModal(false)}
      >
        <ShowResultsContent
          lessonUid={lessonUid}
        />
      </Modal>
    </>
  );
};
